import R from 'ramda'
import {createSelector} from 'reselect'
import L  from 'leaflet'

const levelToRoundingFactor = level => {
  if(level <= 3)  return 0.015
  else if(level <= 6)  return 0.25
  else if(level <= 7) return 0.5
  else if(level <= 8) return 1
  else if(level <= 9) return 2
  else if(level <= 10) return 3
  else if(level <= 12) return 10
  else if(level <= 13) return 15
  else return Math.random() * Date.now()

}
const roundByLevel = (level, latOrLng) =>  {
  const roudingFactor = levelToRoundingFactor(level)
  return Math.round(latOrLng * roudingFactor )
}

const byProximity = R.curry((level, estate)=> {
  const c = estate.coordinates
  return `${roundByLevel(level, c.lat)},${roundByLevel(level,c.lng)}`
})

const groupEstates = createSelector(
  [
    state => state.zoom,
    state => state.estateMap,
  ],
  (level, estates) => R.groupBy(byProximity(level), estates))

const pointsFromGroups = (keyToGroups) => {
  const groups = R.values(keyToGroups)
  const groupKeyToPoint = (acc, estates) => {
    const coordinates = R.pluck('coordinates', estates)
    const center = new L.LatLngBounds(coordinates).getCenter()
    const bounds = R.reduce((acc, estate) => acc.extend(estate.coordinates), new L.LatLngBounds(), estates)
    return R.append( {
      estates,
      bounds,
      coordinates: {
        lat: center.lat,
        lng: center.lng
      }
    }, acc)
  }
  return R.reduce(groupKeyToPoint, [], groups)
}

const groupsPoints = createSelector([groupEstates], pointsFromGroups)
const groupsOfOneAndGroupsSelector = createSelector([groupsPoints], R.partition((g => g.estates.length < 2)))

export const listsOfEstatesSelector = createSelector(groupsOfOneAndGroupsSelector,  R.nth(0) )
export const groupsSelector = createSelector(groupsOfOneAndGroupsSelector,  R.nth(1) )

const estatesSelector = createSelector(listsOfEstatesSelector, R.chain(R.prop('estates')))
const estateListIdsIndexSelector = (state) => state.estateListIdsIndex
const matchingAndNonMatchingEstatesSelector = createSelector([estatesSelector, estateListIdsIndexSelector], (estates, estateListIdsIndex) => R.partition(e => estateListIdsIndex[e.id], estates))
export const matchingEstatesSelector = createSelector([matchingAndNonMatchingEstatesSelector], R.nth(0))
export const nonMatchingEstatesSelector = createSelector([matchingAndNonMatchingEstatesSelector], R.nth(1))



/** WEBPACK FOOTER **
 ** ./app/selectors/groupEstatesByProximity.js
 **/